module.exports = "./img/7cc7092b6fadcecd792a9573ff86ced5.jpg";